import { useState, useEffect } from 'react'
import {useLookup} from "./useLookup";

export const useDocumentTypeLookup = () => {
    const lookupType = 'DOCUMENT_TYPE';
    const {loadingLookupList, lookupList} = useLookup();

    const [loadingDocumentTypeLookupList, setLoadingDocumentTypeLookupList] = useState<boolean>(false);
    const [documentTypeLookupList, setDocumentTypeLookupList] = useState<any>([]);

    useEffect(() => {
        setLoadingDocumentTypeLookupList(loadingLookupList);
        if (lookupList.length) {
            loadDocumentTypeList();
        }
    }, [loadingLookupList, lookupList.length]);

    const loadDocumentTypeList = () => {
        const filterLookupList = lookupList.filter(item => item.type === lookupType);
        setDocumentTypeLookupList(filterLookupList);
    }

    const getDocumentTypeById = (id: any) => {
        if(!documentTypeLookupList) {
            return;
        }
        return documentTypeLookupList.find(item => item.id === Number(id))
    }

    return { loadingDocumentTypeLookupList, documentTypeLookupList, getDocumentTypeById }
}